var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.375 10.125L18.25 12M18.25 12L20.125 13.875M18.25 12L20.125 10.125M18.25 12L16.375 13.875M7.625 8.875L11.5581 4.94194C11.9518 4.54821 12.625 4.82707 12.625 5.38388V18.6161C12.625 19.1729 11.9518 19.4518 11.5581 19.0581L7.625 15.125H5.75755C5.02476 15.125 4.33825 14.7029 4.14364 13.9965C3.96854 13.3608 3.875 12.6913 3.875 12C3.875 11.3087 3.96854 10.6392 4.14364 10.0035C4.33825 9.29706 5.02476 8.875 5.75755 8.875H7.625Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteIcon);
export default __webpack_public_path__ + "static/media/mute-icon.f65ac50d7694ac5d100b6091fb7a49c7.svg";
export { ForwardRef as ReactComponent };